import React, { useState } from 'react';
import './Cobrancas.css';

const Cobrancas = ({ cobrancas = [] }) => {
  const formatData = (date) => {
    return new Date(date).toLocaleDateString('pt-BR');
  };

  return (
    <div className="cobrancas-page-wrapper single-view">
      <div className="cobrancas-top-section full-height">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {cobrancas.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '3rem', color: '#718096' }}>
                    Nenhuma cobrança encontrada
                  </td>
                </tr>
              ) : (
                cobrancas.map(c => (
                  <tr key={c.id}>
                    <td>{c.cliente}</td>
                    <td>{c.valor}</td>
                    <td>{formatData(c.vencimento)}</td>
                    <td><span className="status-badge">{c.status}</span></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Cobrancas;
